module.exports = __webpack_public_path__ + "static/assassin-f8174a173e468a0b534f516a3ad84c31.jpg";